// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ────────────────────────────────────────────────────────────────────────────
   FloorPlanMap — plano de planta a sangre, con zoom y pantalla completa.
   Comparte la iconografía y los botones de los diseñadores (\`cbd-ico\`).
   ──────────────────────────────────────────────────────────────────────────── */

.fpm-page {
  --fpm-accent: #3b82f6;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  height: 100%;
  background: var(--bg-surface, var(--bg-card));
  color: var(--text-primary);
  overflow: hidden;
}
.fpm-page:fullscreen,
.fpm-page.is-fullscreen {
  width: 100vw;
  height: 100vh;
  border-radius: 0;
}

/* ── Barra de herramientas ───────────────────────────────────────────────── */
.fpm-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0.5rem 0.9rem;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  flex-wrap: wrap;
  flex-shrink: 0;
}
.fpm-title {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 700;
  font-size: 0.88rem;
  white-space: nowrap;
}
.fpm-title .cbd-ico { width: 18px; height: 18px; color: var(--fpm-accent); stroke-width: 1.8; }
.fpm-spacer { flex: 1 1; }

.fpm-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 7px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.fpm-btn:hover:not(:disabled) { background: var(--bg-card); color: var(--text-primary); }
.fpm-btn:disabled { opacity: 0.45; cursor: default; }
.fpm-btn.is-primary {
  background: color-mix(in srgb, var(--fpm-accent) 16%, var(--bg-card));
  border-color: color-mix(in srgb, var(--fpm-accent) 55%, var(--border));
  color: var(--text-primary);
}
.fpm-btn.is-danger {
  background: color-mix(in srgb, #ef4444 14%, var(--bg-card));
  border-color: color-mix(in srgb, #ef4444 45%, var(--border));
  color: #fca5a5;
}
.fpm-btn.is-on {
  background: color-mix(in srgb, var(--fpm-accent) 20%, var(--bg-card));
  border-color: var(--fpm-accent);
  color: var(--text-primary);
}
.fpm-btn .cbd-ico { width: 15px; height: 15px; pointer-events: none; }

.fpm-select {
  padding: 5px 9px;
  border-radius: 7px;
  border: 1px solid var(--border);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 0.8rem;
  min-width: 240px;
  max-width: 360px;
}
.fpm-pager {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  color: var(--text-secondary);
}
.fpm-hint {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--fpm-accent) 14%, transparent);
  color: var(--text-secondary);
  white-space: nowrap;
}
.fpm-error { color: #fca5a5; font-size: 0.76rem; }

.fpm-zoom {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 1px;
  border-radius: 8px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
}
.fpm-zoom .fpm-btn { border: 0; background: transparent; }
.fpm-zoom .fpm-btn:hover:not(:disabled) { background: var(--bg-card); }
.fpm-zoom-value { min-width: 52px; justify-content: center; font-variant-numeric: tabular-nums; }

/* ── Cuerpo: panel de tomas + lienzo ─────────────────────────────────────── */
.fpm-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}
.fpm-side {
  width: 236px;
  flex: 0 0 236px;
  border-right: 1px solid var(--border);
  overflow-y: auto;
  background: var(--bg-card);
  padding: 0.6rem 0.55rem 0.9rem;
}
.fpm-body.is-side-collapsed .fpm-side { display: none; }
.fpm-side-head {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin: 0 0 5px 2px;
}
.fpm-empty-side {
  font-size: 0.8rem;
  color: var(--text-muted);
  text-align: center;
  margin-top: 32px;
}
.fpm-pending {
  background: color-mix(in srgb, #f59e0b 20%, var(--bg-card));
  color: var(--text-primary);
  padding: 5px 8px;
  border-radius: 6px;
  font-size: 0.73rem;
  font-weight: 600;
  margin-bottom: 8px;
}
.fpm-hr { border: 0; border-top: 1px solid var(--border); margin: 8px 0; }

.fpm-row-wrap { display: flex; align-items: center; gap: 3px; margin-bottom: 3px; }
.fpm-row {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px;
  text-align: left;
  padding: 4px 6px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
  font-size: 0.78rem;
  cursor: pointer;
}
.fpm-row:hover { background: var(--bg-card); border-color: var(--fpm-accent); }
.fpm-row.is-pending {
  border-color: #f59e0b;
  background: color-mix(in srgb, #f59e0b 18%, var(--bg-card));
}
.fpm-row.is-active { border-color: #f97316; }
.fpm-row.is-wired { border-left: 3px solid #8b5cf6; }
.fpm-row.is-full { border-left: 3px solid #0d9488; }
.fpm-row-code { font-weight: 700; }
.fpm-row-meta { color: var(--text-muted); font-size: 0.72rem; }
.fpm-row-loc {
  font-size: 0.66rem;
  padding: 0 5px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--fpm-accent) 16%, transparent);
  color: var(--text-secondary);
}
.fpm-row-cable { flex-basis: 100%; font-size: 0.69rem; color: #8b5cf6; }
.fpm-row-cable.is-full { color: #0d9488; }
.fpm-row-del {
  flex: 0 0 auto;
  padding: 2px 6px;
  border-radius: 5px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-muted);
  font-size: 0.72rem;
  cursor: pointer;
}
.fpm-row-del:hover { color: #fca5a5; border-color: #ef4444; }

/* ── Lienzo con zoom ─────────────────────────────────────────────────────── */
.fpm-viewport {
  position: relative;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  cursor: grab;
  /* Fondo tipo tablero: deja ver dónde acaba el plano. */
  background-color: var(--bg-surface, var(--bg-card));
  background-image:
    linear-gradient(color-mix(in srgb, var(--border) 45%, transparent) 1px, transparent 1px),
    linear-gradient(90deg, color-mix(in srgb, var(--border) 45%, transparent) 1px, transparent 1px);
  background-size: 28px 28px;
}
.fpm-viewport:active { cursor: grabbing; }
.fpm-viewport.is-placing { cursor: crosshair; }
.fpm-viewport.is-placing:active { cursor: crosshair; }

.fpm-stage {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.28);
}
.fpm-plan {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

.fpm-marker {
  position: absolute;
  /* \`--fpm-inv\` = 1/zoom: el marcador mantiene su tamaño en pantalla. */
  transform: translate(-50%, -50%) scale(var(--fpm-inv, 1));
  transform-origin: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  transition: box-shadow 0.15s;
  z-index: 10;
}
.fpm-marker:hover { box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.65), 0 2px 8px rgba(0, 0, 0, 0.45); }
.fpm-marker.is-active { box-shadow: 0 0 0 3px #f97316, 0 2px 10px rgba(0, 0, 0, 0.4); }
.fpm-marker-txt {
  max-width: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}

.fpm-pop {
  position: absolute;
  bottom: 118%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #1f2937;
  color: #fff;
  border-radius: 8px;
  padding: 8px 11px;
  min-width: 190px;
  font-size: 0.74rem;
  line-height: 1.6;
  white-space: nowrap;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  z-index: 20;
  cursor: default;
}
.fpm-pop-line { color: #d1d5db; }
.fpm-pop-line.is-muted { color: #9ca3af; }
.fpm-pop-line.is-cable { color: #c4b5fd; }
.fpm-pop-line.is-ok { color: #5eead4; }
.fpm-pop-del {
  margin-top: 5px;
  padding-top: 4px;
  border: 0;
  border-top: 1px solid #374151;
  background: none;
  color: #fca5a5;
  font-size: 0.72rem;
  text-align: left;
  cursor: pointer;
}

.fpm-empty-canvas {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: var(--text-muted);
  font-size: 0.9rem;
  text-align: center;
  pointer-events: none;
}
.fpm-empty-canvas .fpm-btn { pointer-events: auto; }
.fpm-empty-ico { width: 56px; height: 56px; opacity: 0.4; }
.fpm-empty-title { color: var(--text-secondary); }

/* ── Buscador, notas y grupo «otras ubicaciones» del panel lateral ───────── */
.fpm-side-search {
  width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  margin-bottom: 8px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 0.78rem;
}
.fpm-side-note {
  margin: 0 2px 6px;
  font-size: 0.7rem;
  line-height: 1.35;
  color: var(--text-muted);
}

/* ── Marcador arrastrable ───────────────────────────────────────────────── */
.fpm-marker {
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
}
.fpm-marker:focus { outline: none; }
.fpm-marker:focus-visible { outline: 2px solid #f8fafc; outline-offset: 2px; }
.fpm-marker.is-dragging {
  cursor: grabbing;
  z-index: 30;
  box-shadow: 0 0 0 3px #fbbf24, 0 2px 10px rgba(0, 0, 0, 0.45);
}

/* ── Acciones del globo ─────────────────────────────────────────────────── */
.fpm-pop-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 5px;
  padding-top: 4px;
  border-top: 1px solid #374151;
}
.fpm-pop-actions .fpm-pop-del {
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}
.fpm-pop-go {
  border: 0;
  background: none;
  padding: 0;
  color: #93c5fd;
  font-size: 0.72rem;
  text-align: left;
  cursor: pointer;
}
.fpm-pop-go:hover { text-decoration: underline; }

/* ── Anotaciones sobre el plano (textos, líneas y flechas) ────────────────
   Todo va DENTRO de \`.fpm-stage\`, que es quien lleva el transform de zoom y
   desplazamiento: por eso quedan clavadas al plano y escalan con él. */
.fpm-sep {
  width: 1px;
  align-self: stretch;
  margin: 2px;
  background: var(--border);
}
.fpm-notes {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
  z-index: 4;
}
.fpm-notes line,
.fpm-notes polygon {
  pointer-events: stroke;
  cursor: pointer;
}
.fpm-note {
  position: absolute;
  transform: translate(-50%, -50%);
  padding: 1px 4px;
  border-radius: 4px;
  white-space: pre;
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
  line-height: 1.15;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.85), 0 0 6px rgba(0, 0, 0, 0.55);
  z-index: 5;
}
.fpm-note.is-selected { outline: 1px dashed #facc15; outline-offset: 2px; }
.fpm-note.is-dragging { cursor: grabbing; }
.fpm-note-input {
  min-width: 120px;
  padding: 1px 4px;
  border-radius: 4px;
  border: 1px solid #facc15;
  background: rgba(15, 23, 42, 0.88);
  color: #f8fafc;
  font: inherit;
}
.fpm-note-input.is-draft {
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 25;
}
.fpm-note-tools {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px;
  border-radius: 8px;
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
}
.fpm-swatch {
  width: 16px;
  height: 16px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.45);
  cursor: pointer;
}
.fpm-swatch.is-on { box-shadow: 0 0 0 2px var(--accent, #3b82f6); }
`, "",{"version":3,"sources":["webpack://./src/components/FloorPlanMap.css"],"names":[],"mappings":"AAAA;;;iFAGiF;;AAEjF;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,YAAY;EACZ,6CAA6C;EAC7C,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE,wBAAwB,EAAE,iBAAiB,EAAE;AAC9F,cAAc,SAAO,EAAE;;AAEvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,gCAAgC,0BAA0B,EAAE,0BAA0B,EAAE;AACxF,oBAAoB,aAAa,EAAE,eAAe,EAAE;AACpD;EACE,qEAAqE;EACrE,sEAAsE;EACtE,0BAA0B;AAC5B;AACA;EACE,2DAA2D;EAC3D,4DAA4D;EAC5D,cAAc;AAChB;AACA;EACE,qEAAqE;EACrE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA,oBAAoB,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE;;AAErE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kEAAkE;EAClE,4BAA4B;EAC5B,mBAAmB;AACrB;AACA,aAAa,cAAc,EAAE,kBAAkB,EAAE;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;AACjC;AACA,qBAAqB,SAAS,EAAE,uBAAuB,EAAE;AACzD,0CAA0C,0BAA0B,EAAE;AACtE,kBAAkB,eAAe,EAAE,uBAAuB,EAAE,kCAAkC,EAAE;;AAEhG,+EAA+E;AAC/E;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;AAChC;AACA,wCAAwC,aAAa,EAAE;AACvD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,2DAA2D;EAC3D,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,UAAU,SAAS,EAAE,mCAAmC,EAAE,aAAa,EAAE;;AAEzE,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAClF;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA,iBAAiB,0BAA0B,EAAE,+BAA+B,EAAE;AAC9E;EACE,qBAAqB;EACrB,2DAA2D;AAC7D;AACA,qBAAqB,qBAAqB,EAAE;AAC5C,oBAAoB,8BAA8B,EAAE;AACpD,mBAAmB,8BAA8B,EAAE;AACnD,gBAAgB,gBAAgB,EAAE;AAClC,gBAAgB,wBAAwB,EAAE,kBAAkB,EAAE;AAC9D;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kEAAkE;EAClE,4BAA4B;AAC9B;AACA,iBAAiB,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACvE,yBAAyB,cAAc,EAAE;AACzC;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;AACA,qBAAqB,cAAc,EAAE,qBAAqB,EAAE;;AAE5D,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,uDAAuD;EACvD,mDAAmD;EACnD;;mGAEiG;EACjG,0BAA0B;AAC5B;AACA,uBAAuB,gBAAgB,EAAE;AACzC,2BAA2B,iBAAiB,EAAE;AAC9C,kCAAkC,iBAAiB,EAAE;;AAErD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sEAAsE;EACtE,yDAAyD;EACzD,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,4BAA4B;EAC5B,WAAW;AACb;AACA,oBAAoB,8EAA8E,EAAE;AACpG,wBAAwB,4DAA4D,EAAE;AACtF;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,eAAe;AACjB;AACA,gBAAgB,cAAc,EAAE;AAChC,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,sBAAsB,cAAc,EAAE;AACtC;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA,6BAA6B,oBAAoB,EAAE;AACnD,iBAAiB,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE;AAC1D,mBAAmB,4BAA4B,EAAE;;AAEjD,+EAA+E;AAC/E;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,8EAA8E;AAC9E;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,oBAAoB,aAAa,EAAE;AACnC,4BAA4B,0BAA0B,EAAE,mBAAmB,EAAE;AAC7E;EACE,gBAAgB;EAChB,WAAW;EACX,6DAA6D;AAC/D;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,oBAAoB,0BAA0B,EAAE;;AAEhD;;uEAEuE;AACvE;EACE,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,UAAU;AACZ;AACA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,uEAAuE;EACvE,UAAU;AACZ;AACA,wBAAwB,2BAA2B,EAAE,mBAAmB,EAAE;AAC1E,wBAAwB,gBAAgB,EAAE;AAC1C;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;EACd,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA,oBAAoB,4CAA4C,EAAE","sourcesContent":["/* ────────────────────────────────────────────────────────────────────────────\r\n   FloorPlanMap — plano de planta a sangre, con zoom y pantalla completa.\r\n   Comparte la iconografía y los botones de los diseñadores (`cbd-ico`).\r\n   ──────────────────────────────────────────────────────────────────────────── */\r\n\r\n.fpm-page {\r\n  --fpm-accent: #3b82f6;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 0;\r\n  height: 100%;\r\n  background: var(--bg-surface, var(--bg-card));\r\n  color: var(--text-primary);\r\n  overflow: hidden;\r\n}\r\n.fpm-page:fullscreen,\r\n.fpm-page.is-fullscreen {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  border-radius: 0;\r\n}\r\n\r\n/* ── Barra de herramientas ───────────────────────────────────────────────── */\r\n.fpm-toolbar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 0.5rem 0.9rem;\r\n  background: var(--bg-card);\r\n  border-bottom: 1px solid var(--border);\r\n  flex-wrap: wrap;\r\n  flex-shrink: 0;\r\n}\r\n.fpm-title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-weight: 700;\r\n  font-size: 0.88rem;\r\n  white-space: nowrap;\r\n}\r\n.fpm-title .cbd-ico { width: 18px; height: 18px; color: var(--fpm-accent); stroke-width: 1.8; }\r\n.fpm-spacer { flex: 1; }\r\n\r\n.fpm-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 4px 9px;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n.fpm-btn:hover:not(:disabled) { background: var(--bg-card); color: var(--text-primary); }\r\n.fpm-btn:disabled { opacity: 0.45; cursor: default; }\r\n.fpm-btn.is-primary {\r\n  background: color-mix(in srgb, var(--fpm-accent) 16%, var(--bg-card));\r\n  border-color: color-mix(in srgb, var(--fpm-accent) 55%, var(--border));\r\n  color: var(--text-primary);\r\n}\r\n.fpm-btn.is-danger {\r\n  background: color-mix(in srgb, #ef4444 14%, var(--bg-card));\r\n  border-color: color-mix(in srgb, #ef4444 45%, var(--border));\r\n  color: #fca5a5;\r\n}\r\n.fpm-btn.is-on {\r\n  background: color-mix(in srgb, var(--fpm-accent) 20%, var(--bg-card));\r\n  border-color: var(--fpm-accent);\r\n  color: var(--text-primary);\r\n}\r\n.fpm-btn .cbd-ico { width: 15px; height: 15px; pointer-events: none; }\r\n\r\n.fpm-select {\r\n  padding: 5px 9px;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n  font-size: 0.8rem;\r\n  min-width: 240px;\r\n  max-width: 360px;\r\n}\r\n.fpm-pager {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.78rem;\r\n  color: var(--text-secondary);\r\n}\r\n.fpm-hint {\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background: color-mix(in srgb, var(--fpm-accent) 14%, transparent);\r\n  color: var(--text-secondary);\r\n  white-space: nowrap;\r\n}\r\n.fpm-error { color: #fca5a5; font-size: 0.76rem; }\r\n\r\n.fpm-zoom {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  padding: 1px;\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n}\r\n.fpm-zoom .fpm-btn { border: 0; background: transparent; }\r\n.fpm-zoom .fpm-btn:hover:not(:disabled) { background: var(--bg-card); }\r\n.fpm-zoom-value { min-width: 52px; justify-content: center; font-variant-numeric: tabular-nums; }\r\n\r\n/* ── Cuerpo: panel de tomas + lienzo ─────────────────────────────────────── */\r\n.fpm-body {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n}\r\n.fpm-side {\r\n  width: 236px;\r\n  flex: 0 0 236px;\r\n  border-right: 1px solid var(--border);\r\n  overflow-y: auto;\r\n  background: var(--bg-card);\r\n  padding: 0.6rem 0.55rem 0.9rem;\r\n}\r\n.fpm-body.is-side-collapsed .fpm-side { display: none; }\r\n.fpm-side-head {\r\n  font-size: 0.68rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  margin: 0 0 5px 2px;\r\n}\r\n.fpm-empty-side {\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n  text-align: center;\r\n  margin-top: 32px;\r\n}\r\n.fpm-pending {\r\n  background: color-mix(in srgb, #f59e0b 20%, var(--bg-card));\r\n  color: var(--text-primary);\r\n  padding: 5px 8px;\r\n  border-radius: 6px;\r\n  font-size: 0.73rem;\r\n  font-weight: 600;\r\n  margin-bottom: 8px;\r\n}\r\n.fpm-hr { border: 0; border-top: 1px solid var(--border); margin: 8px 0; }\r\n\r\n.fpm-row-wrap { display: flex; align-items: center; gap: 3px; margin-bottom: 3px; }\r\n.fpm-row {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: baseline;\r\n  gap: 4px;\r\n  text-align: left;\r\n  padding: 4px 6px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n  font-size: 0.78rem;\r\n  cursor: pointer;\r\n}\r\n.fpm-row:hover { background: var(--bg-card); border-color: var(--fpm-accent); }\r\n.fpm-row.is-pending {\r\n  border-color: #f59e0b;\r\n  background: color-mix(in srgb, #f59e0b 18%, var(--bg-card));\r\n}\r\n.fpm-row.is-active { border-color: #f97316; }\r\n.fpm-row.is-wired { border-left: 3px solid #8b5cf6; }\r\n.fpm-row.is-full { border-left: 3px solid #0d9488; }\r\n.fpm-row-code { font-weight: 700; }\r\n.fpm-row-meta { color: var(--text-muted); font-size: 0.72rem; }\r\n.fpm-row-loc {\r\n  font-size: 0.66rem;\r\n  padding: 0 5px;\r\n  border-radius: 999px;\r\n  background: color-mix(in srgb, var(--fpm-accent) 16%, transparent);\r\n  color: var(--text-secondary);\r\n}\r\n.fpm-row-cable { flex-basis: 100%; font-size: 0.69rem; color: #8b5cf6; }\r\n.fpm-row-cable.is-full { color: #0d9488; }\r\n.fpm-row-del {\r\n  flex: 0 0 auto;\r\n  padding: 2px 6px;\r\n  border-radius: 5px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-muted);\r\n  font-size: 0.72rem;\r\n  cursor: pointer;\r\n}\r\n.fpm-row-del:hover { color: #fca5a5; border-color: #ef4444; }\r\n\r\n/* ── Lienzo con zoom ─────────────────────────────────────────────────────── */\r\n.fpm-viewport {\r\n  position: relative;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  cursor: grab;\r\n  /* Fondo tipo tablero: deja ver dónde acaba el plano. */\r\n  background-color: var(--bg-surface, var(--bg-card));\r\n  background-image:\r\n    linear-gradient(color-mix(in srgb, var(--border) 45%, transparent) 1px, transparent 1px),\r\n    linear-gradient(90deg, color-mix(in srgb, var(--border) 45%, transparent) 1px, transparent 1px);\r\n  background-size: 28px 28px;\r\n}\r\n.fpm-viewport:active { cursor: grabbing; }\r\n.fpm-viewport.is-placing { cursor: crosshair; }\r\n.fpm-viewport.is-placing:active { cursor: crosshair; }\r\n\r\n.fpm-stage {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  transform-origin: 0 0;\r\n  user-select: none;\r\n  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.28);\r\n}\r\n.fpm-plan {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n  pointer-events: none;\r\n}\r\n\r\n.fpm-marker {\r\n  position: absolute;\r\n  /* `--fpm-inv` = 1/zoom: el marcador mantiene su tamaño en pantalla. */\r\n  transform: translate(-50%, -50%) scale(var(--fpm-inv, 1));\r\n  transform-origin: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  padding: 0;\r\n  border: 0;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #fff;\r\n  font-size: 0.6rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\r\n  transition: box-shadow 0.15s;\r\n  z-index: 10;\r\n}\r\n.fpm-marker:hover { box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.65), 0 2px 8px rgba(0, 0, 0, 0.45); }\r\n.fpm-marker.is-active { box-shadow: 0 0 0 3px #f97316, 0 2px 10px rgba(0, 0, 0, 0.4); }\r\n.fpm-marker-txt {\r\n  max-width: 22px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  pointer-events: none;\r\n}\r\n\r\n.fpm-pop {\r\n  position: absolute;\r\n  bottom: 118%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1px;\r\n  background: #1f2937;\r\n  color: #fff;\r\n  border-radius: 8px;\r\n  padding: 8px 11px;\r\n  min-width: 190px;\r\n  font-size: 0.74rem;\r\n  line-height: 1.6;\r\n  white-space: nowrap;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\r\n  z-index: 20;\r\n  cursor: default;\r\n}\r\n.fpm-pop-line { color: #d1d5db; }\r\n.fpm-pop-line.is-muted { color: #9ca3af; }\r\n.fpm-pop-line.is-cable { color: #c4b5fd; }\r\n.fpm-pop-line.is-ok { color: #5eead4; }\r\n.fpm-pop-del {\r\n  margin-top: 5px;\r\n  padding-top: 4px;\r\n  border: 0;\r\n  border-top: 1px solid #374151;\r\n  background: none;\r\n  color: #fca5a5;\r\n  font-size: 0.72rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.fpm-empty-canvas {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 14px;\r\n  color: var(--text-muted);\r\n  font-size: 0.9rem;\r\n  text-align: center;\r\n  pointer-events: none;\r\n}\r\n.fpm-empty-canvas .fpm-btn { pointer-events: auto; }\r\n.fpm-empty-ico { width: 56px; height: 56px; opacity: 0.4; }\r\n.fpm-empty-title { color: var(--text-secondary); }\r\n\r\n/* ── Buscador, notas y grupo «otras ubicaciones» del panel lateral ───────── */\r\n.fpm-side-search {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 4px 8px;\r\n  margin-bottom: 8px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-input);\r\n  color: var(--text-primary);\r\n  font-size: 0.78rem;\r\n}\r\n.fpm-side-note {\r\n  margin: 0 2px 6px;\r\n  font-size: 0.7rem;\r\n  line-height: 1.35;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ── Marcador arrastrable ───────────────────────────────────────────────── */\r\n.fpm-marker {\r\n  user-select: none;\r\n  touch-action: none;\r\n}\r\n.fpm-marker:focus { outline: none; }\r\n.fpm-marker:focus-visible { outline: 2px solid #f8fafc; outline-offset: 2px; }\r\n.fpm-marker.is-dragging {\r\n  cursor: grabbing;\r\n  z-index: 30;\r\n  box-shadow: 0 0 0 3px #fbbf24, 0 2px 10px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n/* ── Acciones del globo ─────────────────────────────────────────────────── */\r\n.fpm-pop-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 5px;\r\n  padding-top: 4px;\r\n  border-top: 1px solid #374151;\r\n}\r\n.fpm-pop-actions .fpm-pop-del {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n  border-top: 0;\r\n}\r\n.fpm-pop-go {\r\n  border: 0;\r\n  background: none;\r\n  padding: 0;\r\n  color: #93c5fd;\r\n  font-size: 0.72rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n.fpm-pop-go:hover { text-decoration: underline; }\r\n\r\n/* ── Anotaciones sobre el plano (textos, líneas y flechas) ────────────────\r\n   Todo va DENTRO de `.fpm-stage`, que es quien lleva el transform de zoom y\r\n   desplazamiento: por eso quedan clavadas al plano y escalan con él. */\r\n.fpm-sep {\r\n  width: 1px;\r\n  align-self: stretch;\r\n  margin: 2px;\r\n  background: var(--border);\r\n}\r\n.fpm-notes {\r\n  position: absolute;\r\n  inset: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: visible;\r\n  pointer-events: none;\r\n  z-index: 4;\r\n}\r\n.fpm-notes line,\r\n.fpm-notes polygon {\r\n  pointer-events: stroke;\r\n  cursor: pointer;\r\n}\r\n.fpm-note {\r\n  position: absolute;\r\n  transform: translate(-50%, -50%);\r\n  padding: 1px 4px;\r\n  border-radius: 4px;\r\n  white-space: pre;\r\n  cursor: move;\r\n  user-select: none;\r\n  line-height: 1.15;\r\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.85), 0 0 6px rgba(0, 0, 0, 0.55);\r\n  z-index: 5;\r\n}\r\n.fpm-note.is-selected { outline: 1px dashed #facc15; outline-offset: 2px; }\r\n.fpm-note.is-dragging { cursor: grabbing; }\r\n.fpm-note-input {\r\n  min-width: 120px;\r\n  padding: 1px 4px;\r\n  border-radius: 4px;\r\n  border: 1px solid #facc15;\r\n  background: rgba(15, 23, 42, 0.88);\r\n  color: #f8fafc;\r\n  font: inherit;\r\n}\r\n.fpm-note-input.is-draft {\r\n  position: absolute;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 25;\r\n}\r\n.fpm-note-tools {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 2px;\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n}\r\n.fpm-swatch {\r\n  width: 16px;\r\n  height: 16px;\r\n  padding: 0;\r\n  border-radius: 50%;\r\n  border: 1px solid rgba(0, 0, 0, 0.45);\r\n  cursor: pointer;\r\n}\r\n.fpm-swatch.is-on { box-shadow: 0 0 0 2px var(--accent, #3b82f6); }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
